export default __webpack_public_path__ + "static/media/logopokemon.03643375.svg";